/**
 * Created by RoryHe on 2020/7/10.
 */
let emailReg = /^(([^<>()\[\]\\.,;:\s@＠"]+(\.[^<>()\[\]\\.,;:\s@＠"]+)*)|(".+"))(@|＠)((\[\d{1,3}\.reg\d{1,3}\.\d{1,3}\.\d{1,3}])|(([\w\-]+\.)+[a-zA-Z]{2,}))$/
let validConst = {
  phoneReg: /^1[3456789]\d{9}$/,
  phone: (value) => {
    return /^1[3456789]\d{9}$/.test(value)
  },
  emailReg: emailReg,
  email: (value) => {
    return emailReg.test(value)
  },
  idCardReg: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/,
  idCard: (value) => { // 11010 832 05 01 492
    let reg15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
    let reg18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/;
    // return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(value)
    return reg15.test(value) || reg18.test(value)
  },
  isEmpty: (value) => {
    if (value == null || value == "" || value == undefined) {
      return false
    } else {
      return true
    }
  },

  legalStrValid: /[`\\\*<>?:："？'’\|\t\v\n\s+#&/＼＃＊｜＆＂＜＞%+]/g,
  /**
   * 合法字符串校验，目前用于上传文件名、表单文本填写
   * @param value
   */
  legalStr: (value) => {
    if (value == null || value == "" || value == undefined) {
      return false
    }
    if (validConst.legalStrValid.test(value)) {
      console.log(value, false)
      validConst.legalStrValid.lastIndex = 0
      return false
    } else {
      console.log(value, true)
      return true
    }
  },

  legalStrIncludeSpaceValid: /[`\\\*<>?:："？'’\|\t\v\n+#&/＼＃＊｜＆＂＜＞%+]/g,
  /*
   * 合法字符串校验，目前用于上传文件名、表单文本填写
   * 该逻辑不校验空格
   * @param value
   */
  legalStrIncludeSpace: (value) => {
    if (value == null || value == "" || value == undefined) {
      return false
    }
    if (validConst.legalStrIncludeSpaceValid.test(value)) {
      console.log(value, false)
      validConst.legalStrIncludeSpaceValid.lastIndex = 0
      return false
    } else {
      console.log(value, true)
      return true
    }
  },

  // 固定电话code
  FixedTelCode: '2',
  FixedTelReg: /^\d{3,4}[-－]\d{7,8}$/,
  // 移动电话code
  MobileTelCode: '1',
  MobileTelReg: /^1[3456789]\d{9}$/,

  // 移动电话或者固话
  telReg: /(^1[3-9]\d{9}$)|(^((\d{3,4}[-－])|(\d{3,4})|(\(\d{3,4}\))|(\（\d{3,4}\）))\d{7,8}$)/,
}
export default validConst
window.validConst = validConst
